import { build } from '../../services/crudFactory';
import { Action } from '../../services/actions.factory';
import { makeMessages, messageActions } from '../../store/message';
import api from "../../services/api.service";
const prefix = 'crudHistoryCargoShipment';
const BASE_PATH = '/lognex/history-cargoshipment';
const crud = build(()=>{},BASE_PATH);


const newTypes = {
    INITIAL_DATE_CHANGE_HANDLER: 'INITIAL_DATE_CHANGE_HANDLER',
    FINAL_DATE_CHANGE_HANDLER: 'FINAL_DATE_CHANGE_HANDLER',
}

const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);

actions.initialDateChangeHandler = (initialDate) => {
    return {
        type: types.INITIAL_DATE_CHANGE_HANDLER,
        initialDate
    }
}

actions.finalDateChangeHandler = (finalDate) => {
    return {
        type: types.FINAL_DATE_CHANGE_HANDLER,
        finalDate
    }
}

actions.downloadReport = () => {
    return (dispatch, getState) => {
        const { filterFields = {} } = getState().crudHistoryCargoShipmentState;

        const filters = Object.keys(filterFields).length
        ? Object.entries(filterFields).map(([field, value]) => ({ field, value }))
        : [];
        
        dispatch(actions.showLoader());
        api
        .post(`/api/v1/${BASE_PATH}/report`, {filters})
        .then((response) => {
            dispatch(actions.hideLoader());
            dispatch(actions.load());
            const data = response.data;            
            const anchor = document.createElement("a");
            anchor.href = data.presigned_url;
            anchor.target = "_blank";
            document.body.append(anchor);
            anchor.click(); 
            anchor.remove();
        })
        .catch((err) => {
            console.log(err);
            dispatch(actions.hideLoader()); 
            dispatch(
                messageActions.messageShowMessages(
                    makeMessages(["Ops! Falha ao exportar Relatório"], "error")
                )
            );
        })
    }
}



export { types, actions }